// Teaching faculty photos

import Arpita from "../../Assets/Images/FacultyImages/TeachingFaculty/Arpita.png";
import Deivasigamani from "../../Assets/Images/FacultyImages/TeachingFaculty/deivasigamani1.jpg";
import Glory from "../../Assets/Images/FacultyImages/TeachingFaculty/glory.jpeg";
import Jebapreetha from "../../Assets/Images/FacultyImages/TeachingFaculty/jebapreetha1.jpeg";
import Kalaiselvan from "../../Assets/Images/FacultyImages/TeachingFaculty/kalaiselvan.jpg";
import Kavipriya from "../../Assets/Images/FacultyImages/TeachingFaculty/Kavipriya.jpg";
import krishnan from "../../Assets/Images/FacultyImages/TeachingFaculty/krishnan.jpeg";
import kumar from "../../Assets/Images/FacultyImages/TeachingFaculty/kumar.jpeg";
import Manikandan from "../../Assets/Images/FacultyImages/TeachingFaculty/Manikandan.jpg";
import MaryFloret from "../../Assets/Images/FacultyImages/TeachingFaculty/Mary_Floret.jpeg";
import MohanaSundaram from "../../Assets/Images/FacultyImages/TeachingFaculty/mohanasundaram.png";
import Muneeshwari from "../../Assets/Images/FacultyImages/TeachingFaculty/Muneeshwari.jpeg";
import Pasupathi from "../../Assets/Images/FacultyImages/TeachingFaculty/Pasupathi.jpeg";
import Prasath from "../../Assets/Images/FacultyImages/TeachingFaculty/prasath1.jpeg";
import Prashath from "../../Assets/Images/FacultyImages/TeachingFaculty/prashath.png";
import PriyaDharshini from "../../Assets/Images/FacultyImages/TeachingFaculty/priya-dharshini.jpeg";
import PriyaDharshani from "../../Assets/Images/FacultyImages/TeachingFaculty/priya_dharshani.jpeg";
import Raghu from "../../Assets/Images/FacultyImages/TeachingFaculty/raghu.png";
import Rajan from "../../Assets/Images/FacultyImages/TeachingFaculty/Rajan.jpeg";
import Kavitha from "../../Assets/Images/FacultyImages/TeachingFaculty/S_Kavitha.jpeg";
import SankarDass from "../../Assets/Images/FacultyImages/TeachingFaculty/sankardass1.JPG";
import Santhosh from "../../Assets/Images/FacultyImages/TeachingFaculty/santhosh.jpeg";
import Srinath from "../../Assets/Images/FacultyImages/TeachingFaculty/Srinath.jpeg";
import Vasuki from "../../Assets/Images/FacultyImages/TeachingFaculty/vasuki.jpg";
import Dinesh from "../../Assets/Images/FacultyImages/TeachingFaculty/dinesh.jpg";
import Jayamurugan from "../../Assets/Images/FacultyImages/TeachingFaculty/jayamurugan.jpeg";
import Vetrivendhan from "../../Assets/Images/FacultyImages/TeachingFaculty/vetrivendhan.JPG";
import AbdulRahman from "../../Assets/Images/FacultyImages/TeachingFaculty/abdulrahman.jpeg";
import Jergin from "../../Assets/Images/FacultyImages/TeachingFaculty/jergin.jpeg";
import Gobika from "../../Assets/Images/FacultyImages/TeachingFaculty/gobika.jpeg";
import VimalRaj from "../../Assets/Images/FacultyImages/TeachingFaculty/vimalraj.jpeg";
import Umabalan from "../../Assets/Images/FacultyImages/TeachingFaculty/umabalan.jpeg";

// Teaching faculties resumes

import DeivasigamaniResume from "../../Assets/Documents/TeachingFacultyResumes/deivasigamani1.pdf";
import GloryResume from "../../Assets/Documents/TeachingFacultyResumes/glory.pdf";
import JebapreethaResume from "../../Assets/Documents/TeachingFacultyResumes/jebapreetha1.docx";
import krishnanResume from "../../Assets/Documents/TeachingFacultyResumes/krishnan.pdf";
import kumarResume from "../../Assets/Documents/TeachingFacultyResumes/kumar.docx";
import MaryFloretResume from "../../Assets/Documents/TeachingFacultyResumes/Mary_Floret.pdf";
import MuneeshwariResume from "../../Assets/Documents/TeachingFacultyResumes/Muneeshwari.docx";
import PasupathiResume from "../../Assets/Documents/TeachingFacultyResumes/Pasupathi.pdf";
import PrasathResume from "../../Assets/Documents/TeachingFacultyResumes/prasath1.doc";
import PrashathResume from "../../Assets/Documents/TeachingFacultyResumes/prashath.docx";
import PriyaDharshiniResume from "../../Assets/Documents/TeachingFacultyResumes/priya-dharshini.pdf";
import PriyaDharshaniResume from "../../Assets/Documents/TeachingFacultyResumes/priya_dharshani.pdf";
import RajanResume from "../../Assets/Documents/TeachingFacultyResumes/Rajan.pdf";
import KavithaResume from "../../Assets/Documents/TeachingFacultyResumes/S_Kavitha.pdf";
import SankarDassResume from "../../Assets/Documents/TeachingFacultyResumes/sankardass1.docx";
import SanthoshResume from "../../Assets/Documents/TeachingFacultyResumes/santhosh.docx";
import SrinathResume from "../../Assets/Documents/TeachingFacultyResumes/Srinath.docx";
import DineshResume from "../../Assets/Documents/TeachingFacultyResumes/dinesh.pdf";
import JayamuruganResume from "../../Assets/Documents/TeachingFacultyResumes/jayamurugan.pdf";
import VetrivendhanResume from "../../Assets/Documents/TeachingFacultyResumes/vetrivendhan.docx";
import AbdulRahmanResume from "../../Assets/Documents/TeachingFacultyResumes/abdulrahman.pdf";
import JerginResume from "../../Assets/Documents/TeachingFacultyResumes/jergin.docx";
import GobikaResume from "../../Assets/Documents/TeachingFacultyResumes/gobika.pdf";
import VimalRajResume from "../../Assets/Documents/TeachingFacultyResumes/vimalraj.docx";
import UmabalanResume from "../../Assets/Documents/TeachingFacultyResumes/umabalan.pdf";

// Non teaching faculties

import Darshini from "../../Assets/Images/FacultyImages/NonTeachingFaculty/Dharshani.png";
import Dhivyadharshini from "../../Assets/Images/FacultyImages/NonTeachingFaculty/Dhivyadharshini.jpg";
import Gokilapriya from "../../Assets/Images/FacultyImages/NonTeachingFaculty/Gokilapriya.jpg";
import Kamali from "../../Assets/Images/FacultyImages/NonTeachingFaculty/kamali.jpeg";
import Pavitra from "../../Assets/Images/FacultyImages/NonTeachingFaculty/Pavitra.jpeg";
import Ramakrishna from "../../Assets/Images/FacultyImages/NonTeachingFaculty/ramakrishna.jpeg";
import Samundeeswari from "../../Assets/Images/FacultyImages/NonTeachingFaculty/Samundeeswari.jpg";
import Shainy from "../../Assets/Images/FacultyImages/NonTeachingFaculty/shainy.jpeg";
import Sneka from "../../Assets/Images/FacultyImages/NonTeachingFaculty/sneka.jpg";
import Varsha from "../../Assets/Images/FacultyImages/NonTeachingFaculty/varsha.jpeg";
import Ponnarasi from "../../Assets/Images/FacultyImages/NonTeachingFaculty/ponnarasi.jpeg";

// Non teaching faculties resumes

import KamaliResume from "../../Assets/Documents/NonTeachinFaculyResumes/kamali.pdf";
import PavitraResume from "../../Assets/Documents/NonTeachinFaculyResumes/pavitra.docx";
import RamakrishnaResume from "../../Assets/Documents/NonTeachinFaculyResumes/ramakrishnan.pdf";
import ShainyResume from "../../Assets/Documents/NonTeachinFaculyResumes/shainy.pdf";
import PonnarasiResume from "../../Assets/Documents/NonTeachinFaculyResumes/ponnarasi.pdf";

const FacultyData = () => {
  const teachingFaculty = [
    {
      image: Jebapreetha,
      name: "Dr. D. Jebapreetha",
      designation: "Associate Professor",
      major: "(Agric.Extension)",
      resume: JebapreethaResume,
    },
    {
      image: Deivasigamani,
      name: "Dr. S. Deivasigamani",
      designation: "Associate Professor",
      major: "(Agronomy)",
      resume: DeivasigamaniResume,
    },
    {
      image: Prasath,
      name: "Mr. S. Prasath",
      designation: "Assistant Professor",
      major: "(Soil Science and Agric. Chemistry)",
      resume: PrasathResume,
    },
    // {
    //   image: Raghu,
    //   name: "Mr. S. Ragu",
    //   designation: "Assistant Physical Director",
    //   major: "(Physical Education Staff)",
    // },
    {
      image: krishnan,
      name: "Mr. T. Krishnan",
      designation: "Librarian",
      major: "(Librarian Staff)",
      resume: krishnanResume,
    },
    {
      image: Glory,
      name: "Ms. K. S. Glory",
      designation: "Assistant Professor",
      major: "(Soil Science and Agric. Chemistry)",
      resume: GloryResume,
    },
    {
      image: Santhosh,
      name: "Mr. A. Santhosh Kumar",
      designation: "Assistant professor",
      major: "(Agricultural Statistics)",
      resume: SanthoshResume,
    },
    {
      image: Prashath,
      name: "Mr. V. Prashath",
      designation: "Assistant professor",
      major: "(Horticulture)",
      resume: PrashathResume,
    },
    {
      image: SankarDass,
      name: "Mr. E. Sankar Doss",
      designation: "Assistant Professor",
      major: "(Agricultural Economics)",
      resume: SankarDassResume,
    },
    {
      image: MaryFloret,
      name: "Dr. V. Mary Floret",
      designation: "Assistant Professor",
      major: "(Entomology)",
      resume: MaryFloretResume,
    },
    {
      image: kumar,
      name: "Dr. R. Kumar",
      designation: "Assistant Professor",
      major: "(Plant Breeding & Genetics)",
      resume: kumarResume,
    },
    // {
    //   image: MohanaSundaram,
    //   name: "Dr. K. Mohana Sundaram",
    //   designation: "Assistant Professor",
    //   major: "(Plant Breeding & Genetics)",
    // },
    // {
    //   image: Kavipriya,
    //   name: "Dr. J. Kavipriya",
    //   designation: "Assistant Professor",
    //   major: "(Agric.Extension)",
    // },
    {
      image: Muneeshwari,
      name: "Dr. P. Muneeshwari",
      designation: "Assistant Professor",
      major: "(Food Science & Nutrition)",
      resume: MuneeshwariResume,
    },
    {
      image: Pasupathi,
      name: "Dr. E. Pasupathi",
      designation: "Assistant Professor",
      major: "(Entomology)",
      resume: PasupathiResume,
    },
    {
      image: Srinath,
      name: "Dr. N. Srinath",
      designation: "Assistant Professor",
      major: "(Agricultural Economics)",
      resume: SrinathResume,
    },
    // {
    //   image: Manikandan,
    //   name: "Dr. K. Manikandan",
    //   designation: "Assistant Professor",
    //   major: "(Plant Pathology)",
    // },
    // {
    //   image: Vasuki,
    //   name: "Dr. A. Vasuki",
    //   designation: "Assistant Professor",
    //   major: "(Agronomy)",
    // },
    // {
    //   image: Kalaiselvan,
    //   name: "Mr. S. Kalaiselvan",
    //   designation: "Assistant Professor",
    //   major: "(Horticulture)",
    // },
    {
      image: Rajan,
      name: "Mr. Rajan L Fradlin Singh",
      designation: "Assistant Professor",
      major: "(Agricultural Microbiology)",
      resume: RajanResume,
    },
    {
      image: Kavitha,
      name: "Dr. S. Kavitha",
      designation: "Assistant Professor",
      major: "(Seed Science and Technology)",
      resume: KavithaResume,
    },
    {
      image: PriyaDharshani,
      name: "Ms. M. Priyadharshini",
      designation: "Assistant Professor",
      major: "(Physical Education Staff)",
      resume: PriyaDharshaniResume,
    },
    // {
    //   image: Arpita,
    //   name: "Ms. Arpita Nag",
    //   designation: "Assistant Professor",
    //   major: "(Horticulture)",
    // },
    {
      image: PriyaDharshini,
      name: "Ms. A. Priya Dharshini",
      designation: "Assistant Professor",
      major: "(Plant Physiology)",
      resume: PriyaDharshiniResume,
    },
    {
      image: Dinesh,
      name: "Mr. M. Dinesh Bhagavathy",
      designation: "Assistant Professor",
      major: "(Computer Science)",
      resume: DineshResume,
    },
    {
      image: Jayamurugan,
      name: "Mr. C. Jayamurugan",
      designation: "Assistant Professor",
      major: "(Plant Pathology)",
      resume: JayamuruganResume,
    },
    {
      image: Vetrivendhan,
      name: "Mr. E. Vetrivendhan",
      designation: "Assistant Professor",
      major: "(Agronomy)",
      resume: VetrivendhanResume,
    },
    {
      image: AbdulRahman,
      name: "Mr. S. Abdul Rahuman",
      designation: "Assistant Professor",
      major: "(Horticulture)",
      resume: AbdulRahmanResume,
    },
    {
      image: Jergin,
      name: "Dr. J. I. Jergin",
      designation: "Assistant Professor",
      major: "(Agriculture Extension)",
      resume: JerginResume,
    },
    {
      image: Gobika,
      name: "Ms. C. Gobika",
      designation: "Assistant Professor",
      major: "(Horticulture)",
      resume: GobikaResume,
    },
    {
      image: VimalRaj,
      name: "Mr. R. Vimal Raj",
      designation: "Assistant Professor",
      major: "(Agronomy)",
      resume: VimalRajResume,
    },
    {
      image: Umabalan,
      name: "Mr. J. Umabalan",
      designation: "Assistant Professor",
      major: "(Plant Breeding)",
      resume: UmabalanResume,
    },
  ];

  const nonTechingFaculty = [
    {
      image: Pavitra,
      name: "Ms. B. Pavitra",
      designation: "Lab Assistant",
      major: "",
      resume: PavitraResume,
    },
    {
      image: Shainy,
      name: "Ms. A. Shainy Staarlit",
      designation: "PA to Principal",
      major: "",
      resume: ShainyResume,
    },
    {
      image: Ramakrishna,
      name: "Mr. B. Ramakrishnan",
      designation: "Field Assistant",
      major: "",
      resume: RamakrishnaResume,
    },
    // {
    //   image: Darshini,
    //   name: "Ms. P. Dharshani",
    //   designation: "Lab Assistant",
    //   major: "",
    // },
    // {
    //   image: Dhivyadharshini,
    //   name: "Ms. A. Dhivya Dharshini",
    //   designation: "Lab Assistant",
    //   major: "",
    // },
    // {
    //   image: Gokilapriya,
    //   name: "Ms. K. Gokila Priya",
    //   designation: "Lab Assistant",
    //   major: "",
    // },
    // {
    //   image: Samundeeswari,
    //   name: "Ms. K. Samundeeswari",
    //   designation: "Lab Assistant",
    //   major: "",
    // },
    {
      image: Kamali,
      name: "Ms. K. Kamali",
      designation: "Field Assistant",
      major: "",
      resume: KamaliResume,
    },
    {
      image: Sneka,
      name: "Ms. K. Sneka",
      designation: "Lab Assistant",
      major: "",
      resume: undefined,
    },
    {
      image: Ponnarasi,
      name: "Ms. S. Ponnarasi",
      designation: "Technical Assistant",
      major: "",
      resume: PonnarasiResume,
    },
    {
      image: Varsha,
      name: "Ms. M. Varsha",
      designation: "Office Assistant",
      major: "",
      resume: undefined,
    },
  ];

  return {
    teachingFaculty,
    nonTechingFaculty,
  };
};

export default FacultyData;
